import React, { useContext } from 'react'

import { UploadContext } from '../Contexts'
import { useCallbackStatic } from '../hooks/utils'
import { FirebaseContext } from '../Contexts'
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";

const UploadProvider = (props) => {
  const {firebaseFunctions} = useContext(FirebaseContext)

  const S3StartUpload = useCallbackStatic(async (currentFiles, setUploading = null, requestHandler = null, setHasError = null) => {
    const { data } = await firebaseFunctions.httpsCallable('getMediaKeys')()

    const s3Config = {
      region: data.options.region,
      credentials: {
          accessKeyId: data.options.accessKey,
        secretAccessKey: data.options.secretKey,
      },
      requestHandler,
    }
    if(!requestHandler) {
      delete s3Config.requestHandler
    }

    const s3Client = new S3Client(s3Config);

    
    const promises = currentFiles.map(async (oFile) => {
      const { name, file } = oFile
  
      console.log(oFile)

      return s3Client.send(new PutObjectCommand({
          Bucket: data.options.bucket,
          ACL: "private",
          Key: `${data.options.keyPrefix}${name}`,
          Body: file,          
      })).then((response) => {
        console.log(`Arquivo enviado com sucesso: ${data.options.bucket}/${data.options.keyPrefix}${name}`)
        if(setUploading) {
          setUploading(false)
        }
      }).catch((err) => {
        console.log('Ocorreu um erro ao enviar o arquivo: ',err)
        if(setUploading) {
          setUploading(false)
        }
        if(setHasError) {
          setHasError('Ocorreu um erro no upload.')
        }
      })
    })

    return promises
  })

  const UploadContextValue = {
    S3StartUpload,
  }

  return (
    <UploadContext.Provider value={UploadContextValue}>
      {props.children}
    </UploadContext.Provider>
  )
}

export default UploadProvider
